import type { Solution } from '../types';

export function reindexSolutions(solutions: Solution[]): Solution[] {
  return solutions.map((solution, index) => ({
    ...solution,
    displayOrder: index + 1
  }));
}

export function normalizeHydratedSolutions(solutions: Solution[]): Solution[] {
  return reindexSolutions(
    solutions
      .map((solution, index) => ({
        solution,
        index
      }))
      .sort((left, right) => {
        const leftOrder =
          typeof left.solution.displayOrder === 'number'
            ? left.solution.displayOrder
            : left.index + 1;
        const rightOrder =
          typeof right.solution.displayOrder === 'number'
            ? right.solution.displayOrder
            : right.index + 1;

        if (leftOrder !== rightOrder) {
          return leftOrder - rightOrder;
        }

        return left.index - right.index;
      })
      .map(({ solution }) => solution)
  );
}
